import { render, staticRenderFns } from "./index.vue?vue&type=template&id=98cb055e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=98cb055e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cb055e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default,ElementsSkeletonsTheConvegni: require('/usr/src/nuxt-app/components/elements/skeletons/TheConvegni.vue').default,ElementsThePaginator: require('/usr/src/nuxt-app/components/elements/ThePaginator.vue').default})
